import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
import _get from 'lodash/get';

const getThemesTitles = ({ theme, themes }) => {
  const finalTheme = _isEmpty(theme) ? themes : theme;

  return (finalTheme || [])
    .map(t => {
      if (_isString(t)) return t;

      return _get(t, 'fields.title');
    })
    .filter(Boolean);
};

const getTopicsTitles = ({ topics }) =>
  (topics || [])
    .map(t => {
      if (_isString(t)) return t;

      return _get(t, 'fields.title');
    })
    .filter(Boolean);

const getEventPageName = ({ pageName, pageShortName }) => {
  const pageNameLower = (pageShortName || pageName || '').toLowerCase();
  return `${pageNameLower}Page`;
};

export { getThemesTitles, getTopicsTitles, getEventPageName };
